import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { selectAuth } from "../../components/auth/auth.selector";
import PMTopStructure from "../../components/payment-link-system/partial-payment/PMTopStructure";
import PMFilters from "../../components/payment-link-system/partial-payment/PMFilters";
import PartialDetailsTable from "../../components/payment-link-system/partial-payment/PartialDetailsTable";
import { fetchPartialPaymentsData } from "../../redux/reducers/apiSlice";
import HelmetWrapper from "../../HelmetWrapper";
import PMLinkStructure from "../../components/payment-link-system/open-partial-link/PMLinkStructure";

const PartialPayment = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const { partialPaymentsData } = useSelector((state) => state.api);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});

  const isAdmin = decryptedText?.account_type === "admin";
  const isGym = decryptedText?.account_type === "gym";
  const isClusterManager = decryptedText?.account_type === "cluster_manager";

  // Check if user is a manager role (cluster_manager, fitness_manager, sales_manager, club_manager)
  const isManagerRole = ["cluster_manager", "fitness_manager", "sales_manager", "club_manager"].includes(decryptedText?.account_type);

  const initialPaymentFilters = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? decryptedText?.name : decryptedText?.gym_name || "",
          value: decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id || "",
        }
      : "",
    selectedStartDate: "",
    selectedEndDate: "",
    searchString: "",
  };
  const [paymentFilters, setPaymentFilters] = useState(initialPaymentFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);
  const initialPaymentData = {
    isPage: 0,
    pagination: [],
    allPaymentInfoData: [],
    allPaymentInfos: null,
  };
  const [allPaymentData, setAllPaymentData] = useState(initialPaymentData);
  const [sendableQPs, setSendableQPs] = useState(
    !isAdmin && !isManagerRole
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : ""
  );

  const onClickReset = () => {
    setPaymentFilters(initialPaymentFilters);
    setSendableQPs("");
  };

  const onClickSearch = () => {
    setSearchFilterApplied(true);

    const searchQP = paymentFilters.searchString
      ? `&search=${paymentFilters.searchString}`
      : "";

    setAllPaymentData((prevs) => ({
      ...prevs,
      isPage: 0,
    }));

    setSendableQPs((prevQP) => prevQP + searchQP);
  };

  useEffect(() => {
    dispatch(
      fetchPartialPaymentsData({
        pageNo: allPaymentData.isPage + 1,
        queryParameters: sendableQPs,
        token: decryptedText?.token,
      })
    );
  }, [sendableQPs, allPaymentData.isPage]);

  // useEffect(() => {
  //   setPaymentFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: decryptedText?.gym_name || "",
  //           value: decryptedText?.gym_id || "",
  //         }
  //       : "",
  //   }));
  // }, [decryptedText?.gym_id]);

  useEffect(() => {
    const gymQP = !isAdmin && !isManagerRole
      ? `&gym_id=${
          decryptedText?.gym_id || decryptedText?.uid || decryptedText?.user_id
        }`
      : paymentFilters.selectedGym?.value
      ? `&gym_id=${paymentFilters.selectedGym.value}`
      : "";
    const statDateQP = paymentFilters.selectedStartDate
      ? `&start_date=${paymentFilters.selectedStartDate}`
      : "";
    const endDateQP = paymentFilters.selectedEndDate
      ? `&end_date=${paymentFilters.selectedEndDate}`
      : "";
    const queryParameters = `${gymQP}${statDateQP}${endDateQP}`;
    setAllPaymentData(initialPaymentData);
    setSendableQPs(queryParameters);
  }, [
    paymentFilters.selectedGym?.value,
    paymentFilters.selectedStartDate,
    paymentFilters.selectedEndDate,
  ]);

  useEffect(() => {
    if (partialPaymentsData?.status && partialPaymentsData?.data?.length > 0) {
      const { data, pagination, partial_stats } = partialPaymentsData || {};

      setAllPaymentData({
        ...allPaymentData,
        allPaymentInfoData: data || [],
        pagination: pagination || [],
        allPaymentInfos: partial_stats,
      });
    } else {
      setAllPaymentData({
        ...allPaymentData,
        allPaymentInfoData: [],
        pagination: [],
        allPaymentInfos: null,
      });
    }
  }, [partialPaymentsData]);

  useEffect(() => {
    if (paymentFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setSendableQPs((prevs) => prevs.replace(/&search=[^&]*/, ""));
    }
  }, [paymentFilters.searchString]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <HelmetWrapper title="WTF: Partial Payement">
      <Container className="bg-cloud-k px-50px" fluid>
        <Tabs>
          <TabList>
            <Tab>Pending Partial Payments</Tab>
            <Tab>All Partial Payments</Tab>
          </TabList>

          <TabPanel>
            <Row>
              <Col>
                <PMLinkStructure userInfoData={decryptedText} />
              </Col>
            </Row>
          </TabPanel>

          <TabPanel>
            <Row>
              <Col>
                <PMTopStructure
                  decryptedText={decryptedText}
                  callFunction={() =>
                    dispatch(
                      fetchPartialPaymentsData({
                        pageNo: allPaymentData.isPage + 1,
                        queryParameters: sendableQPs,
                        token: decryptedText?.token,
                      })
                    )
                  }
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <PMFilters
                  decryptedText={decryptedText}
                  partialPaymentInfo={allPaymentData.allPaymentInfos}
                  paymentFilters={paymentFilters}
                  setPaymentFilters={setPaymentFilters}
                  searchFilterApplied={searchFilterApplied}
                  onClickSearch={onClickSearch}
                  onClickReset={onClickReset}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <PartialDetailsTable
                  allPaymentData={allPaymentData}
                  setAllPaymentData={setAllPaymentData}
                  decryptedText={decryptedText}
                  callFunction={() =>
                    dispatch(
                      fetchPartialPaymentsData({
                        pageNo: allPaymentData.isPage + 1,
                        queryParameters: sendableQPs,
                        token: decryptedText?.token,
                      })
                    )
                  }
                />
              </Col>
            </Row>
          </TabPanel>
        </Tabs>
      </Container>
    </HelmetWrapper>
  );
};

export default PartialPayment;
